import { snakeCase } from 'lodash-es';

export const periodChangeTypeOptions = [
  {
    value: 'year_over_year',
    label: 'Year-over-Year',
    shortLabel: 'YoY',
  },
  {
    value: 'period_over_period',
    label: 'Period-over-Period',
    shortLabel: 'PoP',
  },
];

export const periodChangeTypeCaptures = {
  year_over_year: 'YoY',
  period_over_period: 'PoP',
};

export const yoyChangeKey = 'year_over_year';
export const popChangeKey = 'period_over_period';
export const intraPeriodKey = 'intra_period';

export const intraPeriodChangeTypeOption = {
  label: 'Intra-Period (raw data)',
  value: intraPeriodKey,
};

export const isYoYChange = (changeType) => snakeCase(changeType) === yoyChangeKey;
export const isPoPChange = (changeType) => snakeCase(changeType) === popChangeKey;
export const isIntraPeriod = (changeType) => snakeCase(changeType) === intraPeriodKey;
